import React from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import highchartsAccessibility from 'highcharts/modules/accessibility'
import { sanitizeHTML } from '../../../../shared/utils/common-utils'

highchartsAccessibility(Highcharts)

const options = {
  chart: {
    type: 'column',
    borderRadius: 12,
  },
  legend: {
    enabled: false,
  },
  title: {
    useHTML: true,
    text: '<p class="u-textPrimary u-textSizeMsrp1 u-marginBottom3gu">Probability of income lasting over a 30-year retirement</p>',
  },
  tooltip: {
    enabled: false,
  },
  xAxis: {
    title: {
      useHTML: true,
      text: '<p class="u-textColorDuff u-textPrimary">Annual withdrawal rate (%)</p>',
    },
    categories: ['4%', '5%', '6%', '7%', '8%', '9%'],
  },
  yAxis: {
    title: {
      useHTML: true,
      text: '<p class="y-axis-probability u-textColorDuff u-textPrimary">Probability (%)</p>',
    },
    gridLineDashStyle: 'Dash',
    tickPositions: [0, 25, 50, 75, 100],
  },
  plotOptions: {
    column: {
      pointPadding: 0.1,
      borderWidth: 0,
      dataLabels: {
        enabled: true,
        crop: false,
        overflow: 'allow',
      },
    },
    series: {
      states: {
        hover: {
          enabled: false,
        },
      },
    },
  },
  series: [
    {
      data: [99, 94, 79, 55, 31, 13],
      color: '#009FB8',
    },
  ],
}

export default function WithdrawalRateGraph(props) {
  let descriptionContent = ''
  let paragraphContent = ''

  if (props && props.contentTitle) {
    descriptionContent = props.contentTitle
  }
  if (props && props.content) {
    paragraphContent = props.content
  }

  return (
    <div className='withdrawal-rate-graph-wrap u-bgColorLight u-sizeFull'>
      <div className='withdrawal-rate-graph-content u-sizeConstrained u-bgColorWhite'>
        <div className=' u-pt-paddingVert0  u-sizeFull u-paddingTop12gu u-paddingBottom12gu'>
          {descriptionContent && (
            <>
              <div
                id='withdrawal-rate'
                dangerouslySetInnerHTML={{
                  __html: sanitizeHTML(descriptionContent),
                }}></div>
            </>
          )}

          <div className='withdrawal-rate-graph-and-copy u-sizeConstrained u-flex u-flexWrap u-marginTop10gu'>
            {paragraphContent && (
              <>
                <div className='withdrawal-rate-graph-info u-pt-sizeFull u-size5of12 u-paddingHoriz6gu'>
                  <div
                    className='u-textColorBrand'
                    dangerouslySetInnerHTML={{
                      __html: sanitizeHTML(paragraphContent),
                    }}></div>
                </div>
              </>
            )}

            <div className='withdrawal-rate-graph-card u-pt-sizeFull u-size7of12 u-textColorWhite u-textSizeMsrp7 u-textPrimary'>
              <HighchartsReact highcharts={Highcharts} options={options} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
